import * as api from 'App/api/positioning'
import { calculatePosition } from 'shared/helpers/PositionHelper'
import { CATEGORIES_TYPES } from 'App/modules/categories'
import orderBy from 'lodash/orderBy'

const POSITION_DID_NOT_CHANGE = 'positioning/POSITION_DID_NOT_CHANGE'
export const CHANGE_CATEGORY_POSITION = 'positioning/CHANGE_CATEGORY_POSITION'
export const CHANGE_CATEGORY_POSITION_SUCCESS = 'positioning/CHANGE_CATEGORY_POSITION_SUCCESS'
export const CHANGE_SUBCATEGORY_POSITION = 'positioning/CHANGE_SUBCATEGORY_POSITION'
export const CHANGE_ITEM_POSITION_SUCCESS = 'positioning/CHANGE_ITEM_POSITION_SUCCESS'
export const CHANGE_ITEM_POSITION = 'positioning/CHANGE_ITEM_POSITION'

export function changeCategoryPosition({
  droppedCategory,
  targetId,
  dropDirection,
  categories,
  categoriesIds
}) {
  const position = calculatePosition(categoriesIds.map(id => categories[id]))({
    sourceId: droppedCategory.id,
    targetId,
    dropDirection
  })

  if (position === droppedCategory.position) {
    return dispatch => {
      dispatch({ type: POSITION_DID_NOT_CHANGE })
    }
  }

  let actionType
  if ([CATEGORIES_TYPES.subcategory, CATEGORIES_TYPES.linkSubcategory].includes(droppedCategory.category_type)) {
    // in case we are changing subcategory position
    actionType = CHANGE_SUBCATEGORY_POSITION
  } else {
    actionType = CHANGE_CATEGORY_POSITION
  }

  return (dispatch) => {
    dispatch({
      type: actionType,
      boardId: droppedCategory.board_id,
      category: droppedCategory,
      position,
      categoriesIds: orderCategoriesByPosition(categories, droppedCategory, position)
    })

    api.updateCategoryPosition({
      categoryId: droppedCategory.id,
      position
    })
      .then((category) => {
        dispatch({
          type: CHANGE_CATEGORY_POSITION_SUCCESS,
          category,
          trackingParams: {
            category_id: category.id,
            category_name: category.name,
            position: category.position
          }
        })
      })
  }
}

export function changeItemPosition({
  droppedItem,
  targetId,
  items,
  itemIds,
  selectedCategoryId,
  dropDirection
}) {
  const positionItems = itemIds.map((id) => {
    return { id, position: items[id].position[selectedCategoryId] }
  })

  const position = calculatePosition(positionItems)({
    sourceId: droppedItem.id,
    targetId,
    dropDirection
  })
  if (Number.isNaN(position) || (position === droppedItem.position[selectedCategoryId])) {
    // position didn't changed or failed to calculate new, dispatch nothing
    return dispatch => {
      dispatch({ type: POSITION_DID_NOT_CHANGE })
    }
  }

  return dispatch => {
    dispatch({
      type: CHANGE_ITEM_POSITION,
      boardId: droppedItem.board_id,
      item: droppedItem,
      position,
      selectedCategoryId,
      itemIds: orderItemsByPosition(items, droppedItem, selectedCategoryId, position)
    })

    api.updateItemPosition({
      categoryId: selectedCategoryId,
      itemId: droppedItem.id,
      position
    })
      .then((item) => {
        dispatch({
          type: CHANGE_ITEM_POSITION_SUCCESS,
          trackingParams: {
            item_id: item.id,
            item_name: item.title,
            position: item.position
          }
        })
      })
  }
}

function orderCategoriesByPosition(categories, category, position) {
  categories[category.id].position = position
  return orderBy(Object.values(categories), 'position').map(c => c.id)
}

function orderItemsByPosition(items, item, selectedCategoryId, position) {
  items[item.id].position[selectedCategoryId] = position
  return orderBy(Object.values(items), `position[${selectedCategoryId}]`).map(i => i.id)
}
